<div class="list-skeleton" aria-hidden="true">
  @for (row of rows; track row) {
    <div class="list-skeleton__row">
      <span class="list-skeleton__leading"></span>
      <span class="list-skeleton__line"></span>
    </div>
  }
</div>
